// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__28_wJ","errorLogs":"styles_errorLogs__31rGq"};